module.exports = __webpack_public_path__ + "img/1970East-008_WEB-min.b57a633f.jpg";